<template>
  <div style="padding: 20px;">
    <el-table :data="tableData" border>
      <el-table-column prop="Content" label="任务内容" align="center"></el-table-column>
      <el-table-column prop="CreateTime" label="创建时间" align="center"></el-table-column>
      <el-table-column label="执行进度" align="center">
        <template #default="{ row }">
          {{ row.Tasklype ? '执行中' : '已完成' }}
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="params.page"
      :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="total, sizes, prev, pager, next, jumper" :total="total"
      style="margin-top: 20px;" background>
    </el-pagination>
  </div>
</template>

<script>
import derive from "../../api/derive";
export default {
  data() {
    return {
      tableData: [],
      params: {
        page: 1,
        rows: 10,
        key: "",
        TaskType: ""
      },
      total: 0
    }
  },
  methods: {
    async getRWPDGLList() {
      let res = await derive.RWPDGLList(this.params)
      console.log(res.data.Data);
      this.tableData = res.data.Data.rows
      this.total = res.data.Data.total
    },
    handleSizeChange(limit) {
      this.params.rows = limit
      this.getRWPDGLList()
    },
    handleCurrentChange(page) {
      this.params.page = page
      this.getRWPDGLList()
    }
  },
  created() {
    this.getRWPDGLList()
  },
}
</script>

<style lang="scss" scoped></style>